import React from 'react';
import { WidgetCard } from '../ui/WidgetCard';
export function TokenizationWidget() {
  return <WidgetCard title="Uploaded Works" data-id="element-170">
      <div className="space-y-5" data-id="element-171">
        <div className="flex flex-col items-center" data-id="element-172">
          <div className="text-xl font-medium text-[#376770]" data-id="element-173">12</div>
          <div className="text-sm text-gray-500 mt-1" data-id="element-174">total works</div>
        </div>
        <div className="flex flex-col space-y-3" data-id="element-175">
          <StatusCard label="In Progress" count={4} data-id="element-176" />
          <StatusCard label="Unpublished" count={3} data-id="element-177" />
          <StatusCard label="Published" count={5} data-id="element-178" />
        </div>
      </div>
    </WidgetCard>;
}
function StatusCard({
  label,
  count
}) {
  return <div className="flex items-center py-3 border-t border-gray-100" data-id="element-179">
      <div className="flex-1" data-id="element-180">
        <div className="text-sm font-medium text-gray-700" data-id="element-181">{label}</div>
      </div>
      <div className="text-lg font-normal text-[#376770]" data-id="element-182">{count}</div>
    </div>;
}